import { graphql, useStaticQuery } from "gatsby";
import {
  GatsbyImage,
  ImageDataLike,
  StaticImage,
  getImage,
} from "gatsby-plugin-image";
import styled from "styled-components";

import {
  AspectRatio,
  Box,
  Heading,
  Section,
  Stack,
  Text,
} from "@vinomofo/components";

const GalleryFrame = styled(Box)`
  grid-area: 1/1;
`;

const GalleryImage = styled(Section)`
  grid-area: 1/1;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const GalleryPanel = (): JSX.Element => {
  const imageKey = Math.floor(Math.random() * 5);

  const data: {
    [key: string]: ImageDataLike;
  } = useStaticQuery(graphql`
    {
      imageOne: file(relativePath: { eq: "wine-clubs/carousel-01.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageTwo: file(relativePath: { eq: "wine-clubs/carousel-02.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageThree: file(relativePath: { eq: "wine-clubs/carousel-03.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageFour: file(relativePath: { eq: "wine-clubs/carousel-04.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      imageFive: file(relativePath: { eq: "wine-clubs/carousel-05.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);

  const randomImage = getImage(Object.values(data)[imageKey]);

  return (
    <Section py={60} backgroundColor="white">
      <Box display={["block", "flex"]} alignItems="center">
        <Box flex="1">
          <Text>Let’s be honest…</Text>
          <Stack space={[1, 2]}>
            <Heading as="h2" variant="xl">
              Most wineclubs exist to get rid of the crap.
            </Heading>

            <Text>
              Thing is, we don’t have any crap because <strong>we only sell wines we
              love.</strong>
            </Text>

            <Text>
              You should be boozing like a baller on a dirtbag budget, drinking
              $30 wine for 15 bucks. That’s <strong>epic mofo value.</strong>
            </Text>

            <Text>
              So then it just comes down to you. Don’t like a wine? No stress,
              we’ll drink it ourselves and send you something else. That’s a <strong>100% Mofo Happiness Guarantee.</strong>
            </Text>

            <Text>Check out some of our past Mofo Club wines…</Text>
          </Stack>
        </Box>
        <Box flex="1">
          <AspectRatio ratio={117 / 136} overflow="hidden" display="grid">
            <GalleryImage>
              <GatsbyImage image={randomImage} alt="" loading="eager" />
            </GalleryImage>
            <GalleryFrame>
              <StaticImage src="../../images/wine-clubs/ipad.png" alt="" />
            </GalleryFrame>
          </AspectRatio>
        </Box>
      </Box>
    </Section>
  );
};
